<template>
  <van-overlay :show="show" z-index="999" :lock-scroll="false">
    <div class="showBox">
      <div class="topBox">
        <span>提交报价</span>
        <van-icon name="cross" size="0.63rem" @click="show = false" />
      </div>

      <div class="contentBox" v-show="detailInfo.id">
        <div class="title">{{ detailInfo.title || '' }}</div>
        <div class="descTitle">物料报价清单</div>
        <div class="goodsBox">
          <div v-for="(item,index) in detailInfo.commodityList || []" :key="index">
            <div class="goodsTitle">{{index+1}}、{{item.commodityName || ''}}</div>
            <div class="goodsDesc">需求：{{ item.qualityRequirement ? item.qualityRequirement : '暂无' }}</div>
            <div class="formItemBox">
               <div><span class="tips">*</span>含税单价(￥)</div>
               <div class="formItem">
                  <van-field
                    v-model="item.price"
                    type="number"
                    placeholder="请输入含税单价"
                    @blur="formatAmount(item)"
                    @input="onAmountInput(item)"
                  />
               </div>
            </div>
            <div class="formItemBox">
               <div><span class="tips">*</span>可供数量({{ item.commodityUnit }})</div>
               <div class="formItem">
                  <van-field
                    v-model="item.quotationNum"
                    type="number"
                    :max="item.inquiryNum"
                    placeholder="请输入可供数量"
                    @blur="formatQuantity(item)"
                    @input="onQuantityInput(item)"
                  />
               </div>
            </div>
            <div class="formItemBox">
               <div>留言</div>
               <div class="formItem">
                  <van-field
                    v-model="item.remark"
                    rows="2"
                    autosize
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入留言"
                    show-word-limit
                  />
               </div>
            </div>
          </div>
        </div>
        <div class="totalBox">
          <span style="color: black;">报价总金额</span>
          <span>￥{{ totalAmount }}</span>
        </div>
        <div class="formItemBox">
          <div>整体备注</div>
          <div class="formItem">
            <van-field
              v-model="remark"
              rows="2"
              autosize
              type="textarea"
              maxlength="50"
              placeholder="请输入留言"
              show-word-limit
            />
          </div>
      </div>
      </div>

      <div class="bottomBox">
        <van-button size="small" type="default" plain block>
          已报价 {{ detailInfo.quotationNum ? detailInfo.quotationNum : 0 }}/{{ detailInfo.quotationRound ? detailInfo.quotationRound : 0 }}次
        </van-button>
        <van-button size="small" color="#ee5a52" block @click="submitOffer">提交报价</van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'newOffer',
  props: ['detailObj'],
  data() {
    return {
      show: false,
      detailInfo: {},
      remark: ''
    }
  },
  watch: {
    show(newVal) {
      if(newVal) {
        this.remark = ''
        this.$http.get('/api/srm/app/inquiry/detail', { 
          id: this.detailObj.id
        }).then(({ data }) => {
          this.detailInfo = data ? data : {}
          this.detailInfo.commodityList = this.detailInfo.commodityList.map(item => { 
            return { 
              ...item,
              inquiryCommodityId: item.id,
              quotationNum: item.inquiryNum
            }
          })
        })
      }
    }
  },
  computed: {
    totalAmount() {
      if (!this.detailInfo.commodityList || !Array.isArray(this.detailInfo.commodityList)) {
        return '0.00';
      }
      
      let total = 0;
      this.detailInfo.commodityList.forEach(item => {
        const price = parseFloat(item.price) || 0;
        const quantity = parseFloat(item.quotationNum) || 0;
        total += price * quantity;
      });
      
      return total.toFixed(2);
    }
  },
  methods: {
    submitOffer() { 
      if (!this.detailInfo.commodityList || !Array.isArray(this.detailInfo.commodityList)) {
        this.$toast('请先添加物料报价');
        return;
      }
      
      this.detailInfo.commodityList.forEach(item => {
        if (!item.price || !item.quotationNum) {
          this.$toast('请完善物料报价');
          return;
        }
      });
      
      this.$http.post('/api/srm/app/quotation/insert', {
        inquiryId: this.detailObj.id,
        remark: this.remark,
        itemList: this.detailInfo.commodityList
      }).then(({ code,msg }) => {
        if (code == 200) {
          this.$toast('报价成功');
          this.show = false;
          this.$emit('submitSuccess');
        } else {
          this.$toast(msg || '报价失败');
        }
      })
    },
    showOverlay() {
      this.show = true;
    },
    onAmountInput(item) {
      // 实时限制输入，确保只能输入数字和小数点
      if (item.price || item.price === 0) {
        // 移除所有非数字和非小数点字符
        let value = item.price.toString().replace(/[^\d.]/g, '');
        
        // 防止以小数点开头
        if (value.startsWith('.')) {
          value = '0' + value;
        }
        
        // 确保只有一个小数点
        let parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }
        
        // 限制小数点后最多两位
        if (parts[1] && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2);
        }
        
        // 更新值，使用$set确保响应式更新
        this.$set(item, 'price', value);
      }
    },
    onQuantityInput(item) {
      // 实时限制输入，确保只能输入数字和小数点
      if (item.quotationNum || item.quotationNum === 0) {
        // 移除所有非数字和非小数点字符
        let value = item.quotationNum.toString().replace(/[^\d.]/g, '');
        
        // 防止以小数点开头
        if (value.startsWith('.')) {
          value = '0' + value;
        }
        
        // 确保只有一个小数点
        let parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }
        
        // 限制小数点后最多两位
        if (parts[1] && parts[1].length > 2) {
          value = parts[0] + '.' + parts[1].substring(0, 2);
        }
        
        // 更新值，使用$set确保响应式更新
        this.$set(item, 'quotationNum', value);
      }
    },
    formatAmount(item) {
      // 如果输入值为空或不是数字，设置为空字符串
      if (item.price === '' || item.price === null || item.price === undefined) {
        this.$set(item, 'price', '');
        return;
      }
      
      // 转换为数字
      let value = parseFloat(item.price);
      
      // 如果不是有效数字，设置为空字符串
      if (isNaN(value)) {
        this.$set(item, 'price', '');
        return;
      }
      
      // 不能小于0
      if (value < 0) {
        value = 0;
      }
      
      // 保留两位小数
      try {
        this.$set(item, 'price', parseFloat(value.toFixed(2)));
      } catch (e) {
        // 如果出现任何错误，设置为0
        this.$set(item, 'price', 0);
      }
    },
    formatQuantity(item) {
      // 如果输入值为空或不是数字，设置为空字符串
      if (item.quotationNum === '' || item.quotationNum === null || item.quotationNum === undefined) {
        this.$set(item, 'quotationNum', '');
        return;
      }
      
      // 转换为数字
      let value = parseFloat(item.quotationNum);
      
      // 如果不是有效数字，设置为空字符串
      if (isNaN(value)) {
        this.$set(item, 'quotationNum', '');
        return;
      }
      
      // 不能小于0
      if (value < 0) {
        value = 0;
      }
      
      // 如果超过最大值，设置为最大值
      if (item.inquiryNum && value > item.inquiryNum) {
        value = item.inquiryNum;
      }
      
      // 保留两位小数
      try {
        this.$set(item, 'quotationNum', parseFloat(value.toFixed(2)));
      } catch (e) {
        // 如果出现任何错误，设置为最大值或0
        if (item.inquiryNum) {
          // 确保 item.inquiryNum 是数字类型
          let maxValue = parseFloat(item.inquiryNum);
          if (!isNaN(maxValue)) {
            this.$set(item, 'quotationNum', parseFloat(maxValue.toFixed(2)));
          } else {
            this.$set(item, 'quotationNum', 0);
          }
        } else {
          this.$set(item, 'quotationNum', 0);
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.showBox{ 
  position: absolute;
  width: 90%;
  height: 90vh; /* 设置容器高度 */
  background: #fff;
  top: 5%;
  left: 5%;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column; /* 使用flex布局 */
  .topBox{
    font-size: 0.46rem;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.32rem;
    border-bottom: 1px solid #b3b3b3;
  }
  
  .contentBox { 
    flex: 1; /* 占据剩余空间 */
    width: 100%; 
    overflow-y: auto;
    overflow-x: hidden;
    
    /* 移动端滚动优化 */
    -webkit-overflow-scrolling: touch; /* iOS弹性滚动 */
    -webkit-transform: translateZ(0); /* 硬件加速 */
    transform: translateZ(0);
    
    /* 触摸行为控制 */
    touch-action: pan-y; /* 只允许垂直滚动 */
    overscroll-behavior: contain; /* 防止滚动传播 */
    
    /* 钉钉浏览器兼容 */
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000px;
    perspective: 1000px;
    
    padding:  0.3rem;
    margin-bottom: 0.8rem;
    box-sizing: border-box;
    font-size: 0.42rem;
    .title { 
      font-size: 0.5rem;
      font-weight: bold;
      color: cornflowerblue;
    }
    .descTitle { 
      margin-top: 0.2rem;
      padding: 0.2rem 0;
      border-top: 1px solid #b3b3b3;
      font-size: 0.42rem;
      font-weight: bold;
    }
    .goodsBox { 
      padding: 0.2rem;
      border: 1px solid #b3b3b3;
      border-radius: 4px;
      .goodsTitle { 
        font-size: 0.44rem;
        font-weight: bold;
      }
      .goodsDesc { 
        padding: 0.2rem 0;
        font-size: 0.36rem;
        color: #6d6d6d;
      }
      
    }
    .formItem { 
          flex: 1;
          margin-left: 0.2rem;
          border: 1px solid #b3b3b3;
          border-radius: 4px;
          .van-cell { 
            padding: 2px 8px !important;
          } 
        }
      .formItemBox { 
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 0.3rem;
        
        .tips { 
          color: red;
        }
      }
    .totalBox { 
      font-size: 0.46rem;
      font-weight: bold;
      color: cornflowerblue;
      border: 0.03077rem solid cornflowerblue;
      border-radius: 4px;
      padding: 0.2rem;
      margin: 0.2rem 0;
      display: flex;
      justify-content: space-between;
    }
  }

  .bottomBox { 
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex; 
  }
}
</style>